/** Stable per-browser device id, matching the legacy app's localStorage key. */
export function getMachineId(): string {
  let id = localStorage.getItem('MachineId')
  if (!id) {
    id = crypto.randomUUID()
    localStorage.setItem('MachineId', id)
  }
  return id
}
